import { ApiRoutes } from "@/enums/apiRoutes.enum";
import axios from "@/lib/axios";
import { getSessionId } from "@/utils/sessionId";

export const logService = {
  async getAll(email: string) {
    const response = await axios.get(`${ApiRoutes.FIRELOG}?email=${email}`);
    return response.data;
  },

  async create(log: { level: string; message: string; context: any }) {
    const response = await axios.post(ApiRoutes.FIRELOG, log);
    return response.data;
  },

  async logUsage(event: "login" | "page_view", path: string) {
    await axios.post(ApiRoutes.USAGE_LOG, {
      event,
      path,
      session_id: getSessionId(),
    });
  },
};
